import {MoreVertOutlined} from '@mui/icons-material';
import {Divider, IconButton, Stack, Typography} from '@mui/material';
import {SidebarDialog} from '@ui/SidebarDialog/SidebarDialog';
import {useState} from 'react';
import {LangSelect} from './Menu/LangSelect';
import {TechnicalSupport} from './Menu/TechnicalSupport/TechnicalSuport';
import {UserReport} from './Menu/UserReport/UserReport';
import {Logout} from './Menu/Logout';
import {ColorModeToggle} from './ColorModeToggle';
import {useTranslation} from 'react-i18next';
import {ReportDownloadManager} from './ReportDownloadManager/ReportDownloadManager';

export const UserAvatarMobile = () => {
    const [open, setOpen] = useState(false);
    const {t} = useTranslation('header');

    return (
        <>
            <IconButton onClick={() => setOpen(true)}>
                <MoreVertOutlined />
            </IconButton>
            <SidebarDialog
                open={open}
                onClose={() => setOpen(false)}
                customTitleBlock={
                    <Typography variant='h4'>{t('additionalPossibilities')}</Typography>
                }
            >
                <Stack
                    sx={{
                        '.MuiTypography-root': {
                            backgroundColor: 'initial !important',
                        },
                    }}
                >
                    <ReportDownloadManager />
                    <Divider flexItem />
                    <ColorModeToggle />
                    <Divider flexItem />
                    <LangSelect />
                    <TechnicalSupport />
                    <UserReport />
                    <Logout afterLogout={() => setOpen(false)} />
                </Stack>
            </SidebarDialog>
        </>
    );
};
